import { render, staticRenderFns } from "./AddPPage.vue?vue&type=template&id=92bbb144&"
import script from "./AddPPage.vue?vue&type=script&lang=js&"
export * from "./AddPPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports